import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash/get';
import Header2026 from '../Header2026/Header2026';

const Header = ({ landingPageCartId = null }) => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      allContentfulHeaderMenu(limit: 1, sort: {updatedAt: DESC}) {
        edges {
          node {
            menuName
            showSearch
            headerPageGroups {
              id
              primaryPageName
              primaryPageUrlIfExternal
              primaryPageSelector {
                ... on ContentfulPageDefault {
                  id
                  path
                  title
                }
                ... on ContentfulPageLandingPage {
                  id
                  path
                  title
                }
                ... on ContentfulPageFundraiserSignup2022 {
                  id
                  path
                  title
                }
              }
              column1PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column2PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column3PageLinks {
                id
                pageLevel
                pageName
                pageUrlIfExternal
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
              column3PageCards {
                id
                pageName
                pageDescription
                primaryPageUrlIfExternal
                image {
                  title
                  url
                  id
                }
                pageSelector {
                  ... on ContentfulPageDefault {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageLandingPage {
                    id
                    path
                    title
                  }
                  ... on ContentfulPageFundraiserSignup2022 {
                    id
                    path
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const thisMenu = get(data, 'allContentfulHeaderMenu.edges[0].node');

  if (thisMenu !== null) {
    return (
      <Header2026
        data-testid="Header2026"
        data={thisMenu}
        characterLimit={60}
        landingPageCartId={landingPageCartId}
      />
    );
  }
  return null;
};

Header.propTypes = {
  landingPageCartId: PropTypes.string
};

export default Header;
